import { render, staticRenderFns } from "./xlsySet.vue?vue&type=template&id=12905b5e&scoped=true&"
import script from "./xlsySet.vue?vue&type=script&lang=js&"
export * from "./xlsySet.vue?vue&type=script&lang=js&"
import style0 from "./xlsySet.vue?vue&type=style&index=0&id=12905b5e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12905b5e",
  null
  
)

export default component.exports